export const environment = {
    production: false,
    development: true,
    homolog: false,
    apiRoot: 'https://wapp-closeup-prescription-capture-backend-faahbxg6excsetgz.eastus2-01.azurewebsites.net',
    //apiRoot: 'https://wapp-closeup-dataentry-app-backend-bggthmenaxf8hrbk.eastus2-01.azurewebsites.net',
    apiSimilaridade: 'https://wapp-closeup-prescription-similarity-common-f7e0axd3hmaqd8ae.eastus2-01.azurewebsites.net',
    apiUrl: 'https://devwebmtz.b2clogin.com/devwebmtz.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNUP_SIGNIN&client_id=486305a4-0fa3-47ac-9716-e4bde6c14a0d&nonce=defaultNonce&redirect_uri=https://dev-dataentry.close-upinternational.comt&scope=openid&response_type=id_token&prompt=login',
    apiBaseUrl: 'https://devwebmtz.b2clogin.com/devwebmtz.onmicrosoft.com',
    redirectUrl: 'https://dev-dataentry.close-upinternational.com/es/auth-callback',
    client_id: '486305a4-0fa3-47ac-9716-e4bde6c14a0d',
    loginUrl: 'https://devwebmtz.b2clogin.com/devwebmtz.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNUP_SIGNIN&client_id=486305a4-0fa3-47ac-9716-e4bde6c14a0d&nonce=defaultNonce&redirect_uri=https://dev-dataentry.close-upinternational.com&scope=openid&response_type=id_token&prompt=login',
};

console.log(environment);